import PlayClient from '@empathybroker/tsclient-play';
import { Audit } from '@empathybroker/tsclient-play/dist/models/audit';
import { AuditRequestFilters } from '@empathybroker/tsclient-play/dist/models/audit-request-filters';
import { List } from '@empathybroker/tsclient-play/dist/models/list';
import { PlayResponse } from '@empathybroker/tsclient-play/dist/models/play-response';
import { Sort } from '@empathybroker/tsclient-play/dist/models/sort';

import { ActionContext } from 'vuex';

import { CONTAINER, TYPES } from '../../../config';

import { FilterIdEnum } from '../../../enums';

import { ActionClass, AuditState, ContextState, Dictionary, Filter, Pagination } from '../../../models';

import { AUDIT_CONSTS } from '../../../store/audit/audit.consts';
import { AUTH_CONSTS } from '../../../store/auth/auth.consts';
import { CONTEXT_CONSTS } from '../../../store/context/context.consts';
import { FetchDataAction } from '../../../store/crud/actions/fetch-data.action';

export class ListAction implements ActionClass {

  public static async execute({ commit, state, rootGetters }: ActionContext<AuditState, any>, payload: {
    pagination: Pagination,
    sort: Sort
  }): Promise<PlayResponse> {
    const context: ContextState = rootGetters[`${ CONTEXT_CONSTS.moduleName }/${ CONTEXT_CONSTS.getters.context }`];
    const playClient = CONTAINER.get<(context: ContextState) => PlayClient>(TYPES.PlayClient)(context);
    const authToken: string = rootGetters[`${ AUTH_CONSTS.moduleName }/${ AUTH_CONSTS.getters.token }`];
    try {
      const response: PlayResponse = await playClient.audit(
        authToken,
        ListAction.getAuditRequestFilters(context.filters),
        FetchDataAction.getPlayPage(payload.pagination),
        FetchDataAction.getPlaySort(payload.sort),
        context.query
      );
      const responseData = (response.data as List<Audit>);
      commit(AUDIT_CONSTS.mutations.setData, {
        ...responseData,
        items: (payload.pagination.page === 1) ? responseData.items : state.data.items.concat(responseData.items)
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  private static getAuditRequestFilters(filters: Dictionary<Filter>): AuditRequestFilters {
    return Object.values(filters).reduce((requestFilters: AuditRequestFilters, filter: Filter) => {
      const requestFilterFn = {
        [FilterIdEnum.DATE]: () => ({
          startDate: (!!filter.selectedValues[0] ? new Date(filter.selectedValues[0]) : undefined),
          endDate: (!!filter.selectedValues[1] ? new Date(filter.selectedValues[1]) : undefined)
        }),
        [FilterIdEnum.AUDIT_OBJECT_TYPE]: () => ({ objectType: filter.selectedValues }),
        [FilterIdEnum.AUDIT_ACTION]: () => ({ action: filter.selectedValues })
      }[filter.config.id];
      const requestFilterObj = (!!requestFilterFn && requestFilterFn());
      if (!!requestFilterObj) {
        Object.assign(requestFilters, requestFilterObj);
      }
      return requestFilters;
    }, {});
  }

}
